export default __webpack_public_path__ + "static/media/220301.55739e2d.pdf";